// ------------ Colors ----------- //

// Greys
export const grey90 = '#171717';
export const grey80 = '#333';
export const grey70 = '#4d4c4c';
export const grey60 = '#666';
export const grey50 = '#7f7f7f';
export const grey40 = '#999';
export const grey30 = '#b2b2b2';
export const grey20 = '#cbcaca';
export const grey10 = '#e4e4e3';
export const grey5 = '#f2f2f2';

// Primary
export const brandLight = '#e8f7ff';
export const brandLighter = '#9ed1ee';
export const brand = '#5ab1e1';
export const brandDarker = '#2092d1';
export const brandDark = '#0e74ac';
export const orange = '#f57800';
export const orangeLight = '#fff7ee';
export const red = '#ff5d70';
export const redLight = '#fff2f3';
export const black = `${grey90}`;
export const white = '#fff';
export const background = '#f5f9fd';

// Blacks
export const black90 = 'rgba(0, 0, 0, 0.9)';
export const black80 = 'rgba(0, 0, 0, 0.8)';
export const black70 = 'rgba(0, 0, 0, 0.7)';
export const black60 = 'rgba(0, 0, 0, 0.6)';
export const black50 = 'rgba(0, 0, 0, 0.5)';
export const black40 = 'rgba(0, 0, 0, 0.4)';
export const black30 = 'rgba(0, 0, 0, 0.3)';
export const black20 = 'rgba(0, 0, 0, 0.2)';
export const black10 = 'rgba(0, 0, 0, 0.1)';

// Status
export const success = '#62d493';
export const attention = `${orange}`;
export const error = `${red}`;
